import { useEffect } from 'react'

type Props = {
  ref: React.RefObject<HTMLDivElement>;
  callback: () => void;
}

export const useOutsideAlerter = ({ ref, callback }: Props) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, callback])
}
